export const BASE_URL = "/kot/inventor-import";

export const MAX_FILE_MB = 10;
export const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024;

export const TEMPLATE_FILENAME = "Inventor_Bulk_Import_Template.xlsx";

/**
 * The four figures KOT-107 asks the summary to show. `failedCount` includes duplicates;
 * `duplicateCount` is surfaced underneath it rather than as a fifth total.
 */
export const SUMMARY_TILES = [
  { key: "totalRows", label: "Total Rows Processed", color: "#1E293B" },
  { key: "successCount", label: "Success", color: "#2E7D32" },
  { key: "partialCount", label: "Partial Success", color: "#ED6C02" },
  { key: "failedCount", label: "Failed", color: "#D32F2F" },
];

export const isXlsx = (file) => Boolean(file?.name) && /\.xlsx$/i.test(file.name);

export const XLSX_ONLY_MESSAGE = "Only .xlsx files are supported. Please use the Inventor Bulk Import template.";

/** Client-side pre-checks, so an obviously wrong file never costs a round trip. */
export const validateFile = (file) => {
  if (!file) return "Please choose a file to upload.";
  if (!isXlsx(file)) return XLSX_ONLY_MESSAGE;
  if (file.size > MAX_FILE_BYTES) return `The file is too large. Please upload a file under ${MAX_FILE_MB}MB.`;
  if (file.size === 0) return "The file is empty.";
  return null;
};

export const dropRejectionMessage = (rejections = []) => {
  const codes = rejections.flatMap((rejection) => (rejection?.errors || []).map((error) => error?.code));
  if (codes.includes("too-many-files")) return "Please upload one file at a time.";
  if (codes.includes("file-too-large")) return `The file is too large. Please upload a file under ${MAX_FILE_MB}MB.`;
  return XLSX_ONLY_MESSAGE;
};

export const formatFileSize = (bytes) =>
  bytes >= 1024 * 1024 ? `${(bytes / (1024 * 1024)).toFixed(1)}MB` : `${Math.max(1, Math.round(bytes / 1024))}kb`;
